
import { CommonEnums } from '../../common.enums';

export class DObj_FlatFile_Property {
    dObj_Id: number;
    fileType: string;
    colDelim: string;
    rowDelim: string;
    txtQual: string;
    dateTimeFormat: string;
    skipRows: number;
    escapeChar: string;
    writeHdrFlag: string;
    fileNm: string;
    collItemsDelim: string;
    mapKeysDelim: string;
    nullValue: string;
    inputFormatClass: string;
    outputFormatClass: string;
    orc_Compression: string;
    orc_Stripe_Size: number;
    orc_Row_Index_Stride: number;
    orc_Compress_Size: number;
    orc_Create_Index: string;
    compression: string;
    compressionClass: string;
    fileFormat: string;
    convTable: string;
    distFldSize: number;
    newLineSize: number;
    serdeJarPath: string;
    serdeClass: string;
    serdeProperties: string;
    rootElmnt: string;
    nameSpc: string;
    compressionType: string;
    interCompression: string;
    interCompressionClass: string;
    location: string;
    dateFormat: string;
    parq_Dfs_Blocksize: number;
    parq_Page_Size: number;
    parq_Dictionary_Page_Size: number;
    parq_Block_Size: number;
    parq_Enable_Dictionary: string;
    parq_Compression: string;
    bloom_Filter_Fp_Chance: string;
    caching: string;
    comment: string;
    compaction: string;
    dclocal_Read_Repair_Chance: string;
    default_Time_To_Live: number;
    gc_Grace_Seconds: number;
    min_Index_Interval: number;
    max_Index_Interval: number;
    memtable_Flush_Period: number;
    cache_On_Flush: string;
    read_Repair_Chance: string;
    replicate_On_Write: string;
    speculative_Retry: string;
    compressionCodec: string;
    fld_Offset: number;
    header_Offset: number;
    max_Row_Group_Padding_Size: number;
    min_Row_Count_for_Page_Size: number;
    max_Row_Count_for_Page_Size: number;
    validation: string;
    file_Dir: string;
    ext_Tbl_flag: string;
    ext_Tbl_Loc: string;
    acid_enabled: string;
    num_buckets: string;

    constructor() {
        this.setDefaults();
    }

    setDefaults(): void {
        this.dObj_Id = CommonEnums.defaults.LONG_VAL;
        this.fileType = CommonEnums.defaults.DEFAULT_FILE_TYPE;
        this.colDelim = CommonEnums.defaults.DEFAULT_COLDELIM;
        this.rowDelim = CommonEnums.defaults.DEFAULT_ROWDELIM;
        this.txtQual = CommonEnums.defaults.STRING_EMPTY;
        this.dateTimeFormat = CommonEnums.defaults.DEFAULT_DATETIMEFORMAT;
        this.skipRows = CommonEnums.defaults.NUM_VAL;
        this.escapeChar = CommonEnums.defaults.DEFAULT_ESCAPE_CHAR;
        this.writeHdrFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.fileNm = CommonEnums.defaults.STRING_EMPTY;
        this.collItemsDelim = CommonEnums.defaults.DEFAULT_COLLITEMSDELIM;
        this.mapKeysDelim = CommonEnums.defaults.DEFAULT_MAPKEYSDELIM;
        this.nullValue = CommonEnums.defaults.STRING_EMPTY;
        this.inputFormatClass = CommonEnums.defaults.STRING_EMPTY;
        this.outputFormatClass = CommonEnums.defaults.STRING_EMPTY;
        this.orc_Compression = CommonEnums.defaults.DEFAULT_ORC_COMPRESSION;
        this.orc_Stripe_Size = CommonEnums.defaults.DEFAULT_ORC_STRIPE_SIZE;
        this.orc_Row_Index_Stride = CommonEnums.defaults.DEFAULT_ORC_ROW_INDEX_STRIDE;
        this.orc_Compress_Size = CommonEnums.defaults.DEFAULT_ORC_COMPRESS_SIZE;
        this.orc_Create_Index = "TRUE";
        this.compression = CommonEnums.defaults.DEFAULT_COMPRESSION;
        this.compressionClass = CommonEnums.defaults.STRING_EMPTY;
        this.fileFormat = CommonEnums.defaults.STRING_EMPTY;
        this.serdeJarPath = CommonEnums.defaults.STRING_EMPTY;
        this.serdeClass = CommonEnums.defaults.DEFAULT_SERDECLASS;
        this.serdeProperties = CommonEnums.defaults.DEFAULT_SERDEPROPERTIES;
        this.convTable = CommonEnums.defaults.DEFAULT_CONVTABLE;
        this.distFldSize = CommonEnums.defaults.NUM_VAL;
        this.newLineSize = CommonEnums.defaults.NUM_VAL;
        this.rootElmnt = CommonEnums.defaults.DEFAULT_ROOTELMNT;
        this.nameSpc = CommonEnums.defaults.STRING_EMPTY;
        this.compressionType = CommonEnums.defaults.DEFAULT_ORC_COMPRESSION;
        this.interCompression = CommonEnums.defaults.DEFAULT_COMPRESSION;
        this.interCompressionClass = CommonEnums.defaults.STRING_EMPTY;
        this.location = CommonEnums.defaults.STRING_EMPTY;
        this.dateFormat = CommonEnums.defaults.DEFAULT_DATEFORMAT;
        this.parq_Dfs_Blocksize = CommonEnums.defaults.DEFAULT_PARQ_DFS_BLOCKSIZE;
        this.parq_Page_Size = CommonEnums.defaults.DEFAULT_PARQ_PAGE_SIZE;
        this.parq_Dictionary_Page_Size = CommonEnums.defaults.DEFAULT_PARQ_DICTIONARY_PAGE_SIZE;
        this.parq_Block_Size = CommonEnums.defaults.DEFAULT_PARQ_BLOCK_SIZE;
        this.parq_Enable_Dictionary = CommonEnums.defaults.STRING_VAL_YES;
        this.parq_Compression = CommonEnums.defaults.DEFAULT_PARQ_COMPRESSION;
        this.bloom_Filter_Fp_Chance = "0.01";
        this.caching = "{\"keys\":\"ALL\", \"rows_per_partition\":\"NONE\"}";
        this.comment = CommonEnums.defaults.STRING_EMPTY;
        this.compaction = "SizeTieredCompactionStrategy";
        this.dclocal_Read_Repair_Chance = "0.1";
        this.default_Time_To_Live = CommonEnums.defaults.NUM_VAL;
        this.gc_Grace_Seconds = 864000;
        this.min_Index_Interval = 128;
        this.max_Index_Interval = 2048;
        this.memtable_Flush_Period = CommonEnums.defaults.NUM_VAL;
        this.cache_On_Flush = CommonEnums.defaults.STRING_VAL_NO;
        this.read_Repair_Chance = "0.0";
        this.replicate_On_Write = CommonEnums.defaults.STRING_VAL_YES;
        this.speculative_Retry = "99percentile";
        this.compressionCodec = "CUSTOM";
        this.fld_Offset = CommonEnums.defaults.NUM_VAL;
        this.header_Offset = CommonEnums.defaults.LONG_VAL;
        this.max_Row_Group_Padding_Size = CommonEnums.defaults.NUM_VAL;
        this.min_Row_Count_for_Page_Size = CommonEnums.defaults.PARQUET_MIN_ROW_COUNT_FOR_PAGE_SIZE;
        this.max_Row_Count_for_Page_Size = CommonEnums.defaults.PARQUET_MAX_ROW_COUNT_FOR_PAGE_SIZE;
        this.validation = "FALSE";
        this.file_Dir = CommonEnums.defaults.STRING_EMPTY;
        this.ext_Tbl_flag = CommonEnums.defaults.STRING_EMPTY;
        this.ext_Tbl_Loc = CommonEnums.defaults.STRING_EMPTY;
        this.acid_enabled = CommonEnums.defaults.STRING_FULLY_QUALIFIED_NO;
        this.num_buckets = CommonEnums.defaults.STRING_EMPTY;
    }

    getPrimaryKey(): string {
        return this.dObj_Id.toString();
    }

    copy(): DObj_FlatFile_Property {
        let dObj_FlatFile_PropertyTmp: DObj_FlatFile_Property = new DObj_FlatFile_Property();

        dObj_FlatFile_PropertyTmp.dObj_Id = this.dObj_Id;
        dObj_FlatFile_PropertyTmp.fileType = this.fileType;
        dObj_FlatFile_PropertyTmp.colDelim = this.colDelim;
        dObj_FlatFile_PropertyTmp.rowDelim = this.rowDelim;
        dObj_FlatFile_PropertyTmp.txtQual = this.txtQual;
        dObj_FlatFile_PropertyTmp.dateTimeFormat = this.dateTimeFormat;
        dObj_FlatFile_PropertyTmp.skipRows = this.skipRows;
        dObj_FlatFile_PropertyTmp.escapeChar = this.escapeChar;
        dObj_FlatFile_PropertyTmp.writeHdrFlag = this.writeHdrFlag;
        dObj_FlatFile_PropertyTmp.fileNm = this.fileNm;
        dObj_FlatFile_PropertyTmp.collItemsDelim = this.collItemsDelim;
        dObj_FlatFile_PropertyTmp.mapKeysDelim = this.mapKeysDelim;
        dObj_FlatFile_PropertyTmp.nullValue = this.nullValue;
        dObj_FlatFile_PropertyTmp.inputFormatClass = this.inputFormatClass;
        dObj_FlatFile_PropertyTmp.outputFormatClass = this.outputFormatClass;
        dObj_FlatFile_PropertyTmp.orc_Compression = this.orc_Compression;
        dObj_FlatFile_PropertyTmp.orc_Stripe_Size = this.orc_Stripe_Size;
        dObj_FlatFile_PropertyTmp.orc_Row_Index_Stride = this.orc_Row_Index_Stride;
        dObj_FlatFile_PropertyTmp.orc_Compress_Size = this.orc_Compress_Size;
        dObj_FlatFile_PropertyTmp.orc_Create_Index = this.orc_Create_Index;
        dObj_FlatFile_PropertyTmp.compression = this.compression;
        dObj_FlatFile_PropertyTmp.compressionClass = this.compressionClass;
        dObj_FlatFile_PropertyTmp.fileFormat = this.fileFormat;
        dObj_FlatFile_PropertyTmp.convTable = this.convTable;
        dObj_FlatFile_PropertyTmp.distFldSize = this.distFldSize;
        dObj_FlatFile_PropertyTmp.newLineSize = this.newLineSize;
        dObj_FlatFile_PropertyTmp.serdeJarPath = this.serdeJarPath;
        dObj_FlatFile_PropertyTmp.serdeClass = this.serdeClass;
        dObj_FlatFile_PropertyTmp.serdeProperties = this.serdeProperties;
        dObj_FlatFile_PropertyTmp.rootElmnt = this.rootElmnt;
        dObj_FlatFile_PropertyTmp.nameSpc = this.nameSpc;
        dObj_FlatFile_PropertyTmp.compressionType = this.compressionType;
        dObj_FlatFile_PropertyTmp.interCompression = this.interCompression;
        dObj_FlatFile_PropertyTmp.interCompressionClass = this.interCompressionClass;
        dObj_FlatFile_PropertyTmp.location = this.location;
        dObj_FlatFile_PropertyTmp.dateFormat = this.dateFormat;
        dObj_FlatFile_PropertyTmp.parq_Dfs_Blocksize = this.parq_Dfs_Blocksize;
        dObj_FlatFile_PropertyTmp.parq_Page_Size = this.parq_Page_Size;
        dObj_FlatFile_PropertyTmp.parq_Dictionary_Page_Size = this.parq_Dictionary_Page_Size;
        dObj_FlatFile_PropertyTmp.parq_Block_Size = this.parq_Block_Size;
        dObj_FlatFile_PropertyTmp.parq_Enable_Dictionary = this.parq_Enable_Dictionary;
        dObj_FlatFile_PropertyTmp.parq_Compression = this.parq_Compression;
        dObj_FlatFile_PropertyTmp.bloom_Filter_Fp_Chance = this.bloom_Filter_Fp_Chance;
        dObj_FlatFile_PropertyTmp.caching = this.caching;
        dObj_FlatFile_PropertyTmp.comment = this.comment;
        dObj_FlatFile_PropertyTmp.compaction = this.compaction;
        dObj_FlatFile_PropertyTmp.dclocal_Read_Repair_Chance = this.dclocal_Read_Repair_Chance;
        dObj_FlatFile_PropertyTmp.default_Time_To_Live = this.default_Time_To_Live;
        dObj_FlatFile_PropertyTmp.gc_Grace_Seconds = this.gc_Grace_Seconds;
        dObj_FlatFile_PropertyTmp.min_Index_Interval = this.min_Index_Interval;
        dObj_FlatFile_PropertyTmp.max_Index_Interval = this.max_Index_Interval;
        dObj_FlatFile_PropertyTmp.memtable_Flush_Period = this.memtable_Flush_Period;
        dObj_FlatFile_PropertyTmp.cache_On_Flush = this.cache_On_Flush;
        dObj_FlatFile_PropertyTmp.read_Repair_Chance = this.read_Repair_Chance;
        dObj_FlatFile_PropertyTmp.replicate_On_Write = this.replicate_On_Write;
        dObj_FlatFile_PropertyTmp.speculative_Retry = this.speculative_Retry
        dObj_FlatFile_PropertyTmp.compressionCodec = this.compressionCodec;
        dObj_FlatFile_PropertyTmp.fld_Offset = this.fld_Offset;
        dObj_FlatFile_PropertyTmp.header_Offset = this.header_Offset;
        dObj_FlatFile_PropertyTmp.max_Row_Group_Padding_Size = this.max_Row_Group_Padding_Size;
        dObj_FlatFile_PropertyTmp.min_Row_Count_for_Page_Size = this.min_Row_Count_for_Page_Size;
        dObj_FlatFile_PropertyTmp.max_Row_Count_for_Page_Size = this.max_Row_Count_for_Page_Size;
        dObj_FlatFile_PropertyTmp.validation = this.validation;
        dObj_FlatFile_PropertyTmp.file_Dir = this.file_Dir;
        dObj_FlatFile_PropertyTmp.ext_Tbl_flag = this.ext_Tbl_flag;
        dObj_FlatFile_PropertyTmp.ext_Tbl_Loc = this.ext_Tbl_Loc;
        dObj_FlatFile_PropertyTmp.acid_enabled = this.acid_enabled;
        dObj_FlatFile_PropertyTmp.num_buckets = this.num_buckets;

        return dObj_FlatFile_PropertyTmp;
    }

    copyFrom(dObj_FlatFile_PropertyTmp: DObj_FlatFile_Property): void {
        this.dObj_Id = dObj_FlatFile_PropertyTmp.dObj_Id;
        this.fileType = dObj_FlatFile_PropertyTmp.fileType;
        this.colDelim = dObj_FlatFile_PropertyTmp.colDelim;
        this.rowDelim = dObj_FlatFile_PropertyTmp.rowDelim;
        this.txtQual = dObj_FlatFile_PropertyTmp.txtQual;
        this.dateTimeFormat = dObj_FlatFile_PropertyTmp.dateTimeFormat;
        this.skipRows = dObj_FlatFile_PropertyTmp.skipRows;
        this.escapeChar = dObj_FlatFile_PropertyTmp.escapeChar;
        this.writeHdrFlag = dObj_FlatFile_PropertyTmp.writeHdrFlag;
        this.fileNm = dObj_FlatFile_PropertyTmp.fileNm;
        this.collItemsDelim = dObj_FlatFile_PropertyTmp.collItemsDelim;
        this.mapKeysDelim = dObj_FlatFile_PropertyTmp.mapKeysDelim;
        this.nullValue = dObj_FlatFile_PropertyTmp.nullValue;
        this.inputFormatClass = dObj_FlatFile_PropertyTmp.inputFormatClass;
        this.outputFormatClass = dObj_FlatFile_PropertyTmp.outputFormatClass;
        this.orc_Compression = dObj_FlatFile_PropertyTmp.orc_Compression;
        this.orc_Stripe_Size = dObj_FlatFile_PropertyTmp.orc_Stripe_Size;
        this.orc_Row_Index_Stride = dObj_FlatFile_PropertyTmp.orc_Row_Index_Stride;
        this.orc_Compress_Size = dObj_FlatFile_PropertyTmp.orc_Compress_Size;
        this.orc_Create_Index = dObj_FlatFile_PropertyTmp.orc_Create_Index;
        this.compression = dObj_FlatFile_PropertyTmp.compression;
        this.compressionClass = dObj_FlatFile_PropertyTmp.compressionClass;
        this.fileFormat = dObj_FlatFile_PropertyTmp.fileFormat;
        this.convTable = dObj_FlatFile_PropertyTmp.convTable;
        this.distFldSize = dObj_FlatFile_PropertyTmp.distFldSize;
        this.newLineSize = dObj_FlatFile_PropertyTmp.newLineSize;
        this.serdeJarPath = dObj_FlatFile_PropertyTmp.serdeJarPath;
        this.serdeClass = dObj_FlatFile_PropertyTmp.serdeClass;
        this.serdeProperties = dObj_FlatFile_PropertyTmp.serdeProperties;
        this.rootElmnt = dObj_FlatFile_PropertyTmp.rootElmnt;
        this.nameSpc = dObj_FlatFile_PropertyTmp.nameSpc;
        this.compressionType = dObj_FlatFile_PropertyTmp.compressionType;
        this.interCompression = dObj_FlatFile_PropertyTmp.interCompression;
        this.interCompressionClass = dObj_FlatFile_PropertyTmp.interCompressionClass;
        this.location = dObj_FlatFile_PropertyTmp.location;
        this.dateFormat = dObj_FlatFile_PropertyTmp.dateFormat;
        this.parq_Dfs_Blocksize = dObj_FlatFile_PropertyTmp.parq_Dfs_Blocksize;
        this.parq_Page_Size = dObj_FlatFile_PropertyTmp.parq_Page_Size;
        this.parq_Dictionary_Page_Size = dObj_FlatFile_PropertyTmp.parq_Dictionary_Page_Size;
        this.parq_Block_Size = dObj_FlatFile_PropertyTmp.parq_Block_Size;
        this.parq_Enable_Dictionary = dObj_FlatFile_PropertyTmp.parq_Enable_Dictionary;
        this.parq_Compression = dObj_FlatFile_PropertyTmp.parq_Compression;
        this.bloom_Filter_Fp_Chance = dObj_FlatFile_PropertyTmp.bloom_Filter_Fp_Chance;
        this.caching = dObj_FlatFile_PropertyTmp.caching;
        this.comment = dObj_FlatFile_PropertyTmp.comment;
        this.compaction = dObj_FlatFile_PropertyTmp.compaction;
        this.dclocal_Read_Repair_Chance = dObj_FlatFile_PropertyTmp.dclocal_Read_Repair_Chance;
        this.default_Time_To_Live = dObj_FlatFile_PropertyTmp.default_Time_To_Live;
        this.gc_Grace_Seconds = dObj_FlatFile_PropertyTmp.gc_Grace_Seconds;
        this.min_Index_Interval = dObj_FlatFile_PropertyTmp.min_Index_Interval;
        this.max_Index_Interval = dObj_FlatFile_PropertyTmp.max_Index_Interval;
        this.memtable_Flush_Period = dObj_FlatFile_PropertyTmp.memtable_Flush_Period;
        this.cache_On_Flush = dObj_FlatFile_PropertyTmp.cache_On_Flush;
        this.read_Repair_Chance = dObj_FlatFile_PropertyTmp.read_Repair_Chance;
        this.replicate_On_Write = dObj_FlatFile_PropertyTmp.replicate_On_Write;
        this.speculative_Retry = dObj_FlatFile_PropertyTmp.speculative_Retry;
        this.compressionCodec = dObj_FlatFile_PropertyTmp.compressionCodec;
        this.fld_Offset = dObj_FlatFile_PropertyTmp.fld_Offset;
        this.header_Offset = dObj_FlatFile_PropertyTmp.header_Offset;
        this.max_Row_Group_Padding_Size = dObj_FlatFile_PropertyTmp.max_Row_Group_Padding_Size;
        this.min_Row_Count_for_Page_Size = dObj_FlatFile_PropertyTmp.min_Row_Count_for_Page_Size;
        this.max_Row_Count_for_Page_Size = dObj_FlatFile_PropertyTmp.max_Row_Count_for_Page_Size;
        this.validation = dObj_FlatFile_PropertyTmp.validation;
        this.file_Dir = dObj_FlatFile_PropertyTmp.file_Dir;
        this.ext_Tbl_flag = dObj_FlatFile_PropertyTmp.ext_Tbl_flag;
        this.ext_Tbl_Loc = dObj_FlatFile_PropertyTmp.ext_Tbl_Loc;
        this.acid_enabled = dObj_FlatFile_PropertyTmp.acid_enabled;
        this.num_buckets = dObj_FlatFile_PropertyTmp.num_buckets;
    }

    compare(dObj_FlatFile_PropertyTmp: DObj_FlatFile_Property): string {
        let dObj_FlatFile_PropertyString: string = this.toString(false);
        let dObj_FlatFile_PropertyTmpString: string = dObj_FlatFile_PropertyTmp.toString(false);

        if (dObj_FlatFile_PropertyString != dObj_FlatFile_PropertyTmpString) {
            return dObj_FlatFile_PropertyString + ', ' + dObj_FlatFile_PropertyTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "DObj_FlatFile_Property [dObj_Id=" + this.dObj_Id + ", fileType=" + this.fileType +
            ", colDelim=" + this.colDelim + ", rowDelim=" + this.rowDelim +
            ", txtQual =" + this.txtQual + ", dateTimeFormat=" + this.dateTimeFormat + ", skipRows=" + this.skipRows +
            ", escapeChar=" + this.escapeChar + ", writeHdrFlag=" + this.writeHdrFlag +
            ", fileNm =" + this.fileNm + ", collItemsDelim=" + this.collItemsDelim + ", mapKeysDelim=" + this.mapKeysDelim +
            ", nullValue=" + this.nullValue + ", inputFormatClass=" + this.inputFormatClass +
            ", outputFormatClass =" + this.outputFormatClass + ", orc_Compression=" + this.orc_Compression + ", orc_Stripe_Size=" + this.orc_Stripe_Size +
            ", orc_Row_Index_Stride=" + this.orc_Row_Index_Stride + ", orc_Compress_Size=" + this.orc_Compress_Size +
            ", orc_Create_Index =" + this.orc_Create_Index + ", compression=" + this.compression + ", compressionClass=" + this.compressionClass +
            ", fileFormat=" + this.fileFormat + ", convTable=" + this.convTable +
            ", distFldSize =" + this.distFldSize + ", newLineSize=" + this.newLineSize + ", serdeJarPath=" + this.serdeJarPath +
            ", serdeClass=" + this.serdeClass + ", serdeProperties=" + this.serdeProperties +
            ", rootElmnt =" + this.rootElmnt + ", nameSpc=" + this.nameSpc + ", compressionType=" + this.compressionType +
            ", interCompression=" + this.interCompression + ", interCompressionClass=" + this.interCompressionClass +
            ", location =" + this.location + ", dateFormat=" + this.dateFormat + ", parq_Dfs_Blocksize=" + this.parq_Dfs_Blocksize +
            ", parq_Page_Size=" + this.parq_Page_Size + ", parq_Dictionary_Page_Size=" + this.parq_Dictionary_Page_Size +
            ", parq_Block_Size =" + this.parq_Block_Size + ", parq_Enable_Dictionary=" + this.parq_Enable_Dictionary + ", parq_Compression=" + this.parq_Compression +
            ", bloom_Filter_Fp_Chance=" + this.bloom_Filter_Fp_Chance + ", caching=" + this.caching +
            ", comment =" + this.comment + ", compaction=" + this.compaction + ", dclocal_Read_Repair_Chance=" + this.dclocal_Read_Repair_Chance +
            ", default_Time_To_Live=" + this.default_Time_To_Live + ", gc_Grace_Seconds=" + this.gc_Grace_Seconds +
            ", min_Index_Interval =" + this.min_Index_Interval + ", max_Index_Interval=" + this.max_Index_Interval + ", memtable_Flush_Period=" + this.memtable_Flush_Period +
            ", cache_On_Flush=" + this.cache_On_Flush + ", read_Repair_Chance=" + this.read_Repair_Chance +
            ", replicate_On_Write =" + this.replicate_On_Write + ", speculative_Retry=" + this.speculative_Retry + ", compressionCodec=" + this.compressionCodec +
            ", fld_Offset=" + this.fld_Offset + ", header_Offset=" + this.header_Offset +
            ", max_Row_Group_Padding_Size =" + this.max_Row_Group_Padding_Size + ", max_Row_Count_for_Page_Size=" + this.max_Row_Count_for_Page_Size + ", max_Row_Count_for_Page_Size=" + this.max_Row_Count_for_Page_Size +
            ", validation=" + this.validation + ", file_Dir=" + this.file_Dir +
            ", ext_Tbl_flag =" + this.ext_Tbl_flag + ", ext_Tbl_Loc=" + this.ext_Tbl_Loc + ", acid_enabled=" + this.acid_enabled +
            ", num_buckets=" + this.num_buckets;

        if (isNotCompare) {
            str += ''
        }

        str += ']';

        return str;
    }
}